// StudyDestinations.js — P10 section 6. Cards from the Country CMS model,
// linking to /country/:slug. Turkey is (as of this writing) the only
// consistently active destination — the CSS is built so 1-2 cards still
// read as a deliberate, centred showcase rather than a sparse grid with
// leftover empty space.
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getCountries } from '../services/api';
import './StudyDestinations.css';

export default function StudyDestinations() {
  const [countries, setCountries] = useState([]);

  useEffect(() => {
    getCountries()
      .then((data) => {
        const list = (Array.isArray(data) ? data : (data.results || [])).filter((c) => c.is_active !== false);
        setCountries(list);
      })
      .catch(() => {});
  }, []);

  if (countries.length === 0) return null;

  return (
    <section className="destinations-section" aria-labelledby="destinations-heading">
      <div className="destinations-container">
        <div className="destinations-header">
          <h2 id="destinations-heading" className="destinations-title">Where you could study</h2>
          <p className="destinations-subtitle">Every destination we place students in, with dedicated support from application to arrival.</p>
        </div>

        <div className={`destinations-grid destinations-grid--count-${Math.min(countries.length, 3)}`}>
          {countries.map((c) => (
            <Link key={c.id} to={`/country/${c.slug}`} className="destination-card">
              <div className="destination-card-media">
                {(c.effective_cover_image_url || c.cover_image_url) ? (
                  <img
                    src={c.effective_cover_image_url || c.cover_image_url}
                    alt=""
                    className="destination-card-image"
                    width={400}
                    height={260}
                    loading="lazy"
                    decoding="async"
                  />
                ) : (
                  <div className="destination-card-fallback" aria-hidden="true">{c.flag_emoji || '🌍'}</div>
                )}
              </div>
              <div className="destination-card-body">
                <h3 className="destination-card-title">
                  {c.flag_emoji && <span aria-hidden="true">{c.flag_emoji} </span>}
                  {c.name}
                </h3>
                {c.short_description && <p className="destination-card-description">{c.short_description}</p>}
                <span className="destination-card-link">Explore {c.name} →</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
